var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8335 3.33331L2.5 3.33331",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.1665 15.8333L2.5 15.8333",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 15.8333L14.1665 15.8333",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 9.58331L9.1665 9.58331",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 3.33331L15.8335 3.33331",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.1665 9.58331L2.5 9.58331",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8188 1.73013C13.0234 1.8147 13.1855 1.97693 13.27 2.18112C13.3335 2.33426 13.3335 2.52841 13.3335 2.91669L13.3335 3.75003C13.3335 4.13831 13.3335 4.33246 13.27 4.4856C13.1855 4.68979 13.0234 4.85202 12.8188 4.93658C12.666 5.00003 12.4717 5.00003 12.0835 5.00003C11.6953 5.00003 11.501 5.00003 11.3481 4.93658C11.1436 4.85202 10.9814 4.68979 10.897 4.4856C10.8335 4.33246 10.8335 4.13831 10.8335 3.75003L10.8335 2.91669C10.8335 2.52841 10.8335 2.33426 10.897 2.18112C10.9814 1.97693 11.1436 1.8147 11.3481 1.73013C11.501 1.66669 11.6953 1.66669 12.0835 1.66669C12.4717 1.66669 12.666 1.66669 12.8188 1.73013Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1519 14.2301C11.3564 14.3147 11.5186 14.4769 11.603 14.6811C11.6665 14.8343 11.6665 15.0284 11.6665 15.4167L11.6665 16.25C11.6665 16.6383 11.6665 16.8324 11.603 16.9856C11.5186 17.1898 11.3564 17.352 11.1519 17.4366C10.999 17.5 10.8047 17.5 10.4165 17.5C10.0283 17.5 9.83398 17.5 9.68115 17.4366C9.47656 17.352 9.31445 17.1898 9.22998 16.9856C9.1665 16.8324 9.1665 16.6383 9.1665 16.25L9.1665 15.4167C9.1665 15.0284 9.1665 14.8343 9.22998 14.6811C9.31445 14.4769 9.47656 14.3147 9.68115 14.2301C9.83398 14.1667 10.0283 14.1667 10.4165 14.1667C10.8047 14.1667 10.999 14.1667 11.1519 14.2301Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.65186 7.98013C8.85645 8.0647 9.01855 8.22693 9.10303 8.43109C9.1665 8.58426 9.1665 8.77844 9.1665 9.16669L9.1665 10C9.1665 10.3883 9.1665 10.5824 9.10303 10.7356C9.01855 10.9398 8.85645 11.102 8.65186 11.1866C8.49902 11.25 8.30469 11.25 7.9165 11.25C7.52832 11.25 7.33398 11.25 7.18115 11.1866C6.97656 11.102 6.81445 10.9398 6.72998 10.7356C6.6665 10.5824 6.6665 10.3883 6.6665 10L6.6665 9.16669C6.6665 8.77844 6.6665 8.58426 6.72998 8.43109C6.81445 8.22693 6.97656 8.0647 7.18115 7.98013C7.33398 7.91669 7.52832 7.91669 7.9165 7.91669C8.30469 7.91669 8.49902 7.91669 8.65186 7.98013Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterHistory);
export default __webpack_public_path__ + "static/media/filter-history.04fe2e64574670a9533c168529e418f5.svg";
export { ForwardRef as ReactComponent };